import axios, { AxiosRequestConfig } from 'axios';
import { getJWT } from 'src/helper/localStore/getJWT';
import {
  BillingFormOutputDTO,
  BillingFormInputDTO,
} from './billingFormDTO';
import { IsAuthorized } from 'src/authentication/IsAuthorized';

class BillingFormServices {

  async uploadConciliation(data: Object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/billingform/mongo_extracts/upload/`,
        data,
        {
          headers: {
            'authentication-token': getJWT()!,
            "Accept": "application/json",
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getExtract(queryParamsString?: string): Promise<Blob> {
    try {
      const token = getJWT();
      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/mongo_extracts/download/`;
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        responseType: 'blob', // Configuración para recibir binarios
      };
      if (queryParamsString) {
        url += `?${queryParamsString}`;
      }
      const res = await axios.get(url, config);
      return res.data; // Retorna el Blob directamente
    } catch (error) {
      IsAuthorized(error);
      throw error;
    }
  }


  async getBillingFormList(queryParamsString?: string): Promise<BillingFormOutputDTO[]> {
    try {
      const token = getJWT()
      // let url = `${process.env.REACT_APP_URL_RESERVATION}/business-unit/`
      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/billingforms/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
      }
      // Si hay queryParams como cadena, añádelos a la URL.
      if (queryParamsString) {
        url += `?${queryParamsString}`
      }
      const res = await axios.get(url, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getCurrencyBaseRelations(queryParamsString?: string): Promise<BillingFormOutputDTO[]> {
    try {
      const token = getJWT()
      // let url = `${process.env.REACT_APP_URL_RESERVATION}/business-unit/`
      let url = `${process.env.REACT_APP_URL_PAYMENT}/currency/currency_history_bases/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
      }
      // Si hay queryParams como cadena, añádelos a la URL.
      if (queryParamsString) {
        url += `?${queryParamsString}`
      }
     const res = await axios.get(url, config);
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getCurrencyBases(queryParamsString?: string  ): Promise<BillingFormOutputDTO[]> {
    try {
      const token = getJWT()
      let url = `${process.env.REACT_APP_URL_PAYMENT}/currency/currency_bases/`

      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
      }
      // Si hay queryParams como cadena, añádelos a la URL.
      if (queryParamsString) {
        url += `?${queryParamsString}`
      }
      const res = await axios.get(url, config);
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAllCurrencys(): Promise<any> {
    try {
      const token = getJWT()
      let url = `${process.env.REACT_APP_URL_PAYMENT}/currency/`

      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
      }
      const response = await axios.get(url, config);
      return response.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async uploadBillingForm(data: Object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/billingform/billingforms/`,
        data,
        {
          headers: {
            'authentication-token': getJWT()!,
            "Accept": "application/json",
          },

        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateCurrencyBaseRelation(id:string,data:Object): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/currency/currency_history_bases/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
      }
      const response = await axios.post(url, data, config);

      return response.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteCurrencyBaseRelation(id:string,data:Object): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/currency/currency_history_bases/${id}`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
      }
      const response = await axios.patch(url, data, config);
      return response.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editCurrencyBaseRelation(id:string,data:Object): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/billingforms/${id}`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
      }
      const response = await axios.patch(url, data, config);
      return response.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getHistoricalCurrencyHistoryBases(params: any = {}): Promise<any[]> {
    try {
      const config: any = {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      };
  
      if (params.download_excel) {
        config.responseType = 'blob'; 
      }

      const res = await axios.get(
        `${process.env.REACT_APP_URL_PAYMENT}/currency/currency_history_bases/full_historical/`,
        config
      );
  
      return res.data
    } catch (error) {
      console.log(error)
      IsAuthorized(error)
      throw error
    }
  }

  async downloadFiles(fileUrl:string): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/billingform_download_files/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        responseType: 'arraybuffer',
        params:{
          fileUrl
        }
      }
      const response = await axios.get(url,config);
      return response
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getBankExtracts(params:{}): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/mongo_extracts/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        params
      }
      const response = await axios.get(url,config);
      return response
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateBankExtract(params:{}): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/mongo_extracts/update_bank_extract/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        params
      }
      const response = await axios.put(url,{},config);
      return response
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getById(id:number): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/billingforms/${id}`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
      }
      const response = await axios.get(url,config);
      return response
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editReceiptNumber(billingform_id :number, receipt_number :string, billingform_payment_id:number): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/update_receipt/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        params:{
          billingform_id,
          receipt_number,
          billingform_payment_id
        }
      }
      const response = await axios.put(url,{},config);
      return response
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateReceiptNumber(billingform_id :number, billingform_payment_id:number): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/get_receipt_from_billing/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        params:{
          billingform_id,
          billingform_payment_id
        }
      }
      const response = await axios.put(url,{},config);
      return response
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteExtractBank(bank_name:string, hash_id:string): Promise<any> {
    try {
      const token = getJWT()

      let url = `${process.env.REACT_APP_URL_PAYMENT}/billingform/mongo_extracts/delete_bank_extract/`
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': token! },
        params:{
          bank_name,
          hash_id
        }
      }
      const response = await axios.delete(url,config);
      return response
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const billingFormServices = new BillingFormServices()
